import Modal from "react-bootstrap/Modal";
import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { MediaOutletContext } from "../../data/media_outlet_context_management";
import useMediaOutletUpdateApi from "../../data/use_media_outlet_update_api";
import CharacterLimitIndicator from "../../../products/reusable/character_limit_indicator";
import SaveSpinnerButton from "../../../profiles/SaveSpinnerButton";
import ServerErrorAlert from "../../../profiles/ServerErrorAlert";
import { descriptionMaxLength, mediaOutletOverviewYupSchema } from "../../../../yup_schemas/media_outlet_schema";

const OVERVIEW_ERROR_LABELS = { description: "Overview" };

// Overview (description) edit body. The section is titled "Overview" on the page but the column is
// `description`, so the form keeps the column name for the field and labels it Overview.
function OverviewModalBody({ close }) {
  const context = useContext(MediaOutletContext);
  const { mediaOutlet, isUpdating, generalError } = context;
  const { updateMediaOutlet } = useMediaOutletUpdateApi({ ...context });

  const [descriptionLength, setDescriptionLength] = useState(mediaOutlet.description?.length || 0);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(mediaOutletOverviewYupSchema),
  });

  // The field's own onChange has to be called through, not replaced: the form reads its values from
  // what the registration recorded, so an onChange that only drives the counter would submit the
  // value the textarea started with.
  const descriptionField = register("description");
  const handleDescriptionChange = (event) => {
    descriptionField.onChange(event);
    setDescriptionLength(event.target.value.length);
  };

  const onSubmit = async (data, event) => {
    event.preventDefault();
    // An emptied textarea means "no overview", which the column stores as null — an empty string
    // would render as an overview that is simply blank.
    await updateMediaOutlet({ description: data.description?.length ? data.description : null });
  };

  return (
    <>
      <Modal.Body>
        <ServerErrorAlert generalError={generalError} labelMap={OVERVIEW_ERROR_LABELS} />
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3 row">
            <label htmlFor="description" className="col-12 col-form-label">
              Overview
            </label>
            <div className="col-12">
              <textarea
                id="description"
                className="form-control"
                rows="6"
                {...descriptionField}
                defaultValue={mediaOutlet.description}
                onChange={handleDescriptionChange}
              />
              <div className="mt-2">
                <CharacterLimitIndicator
                  fieldName="description"
                  length={descriptionLength}
                  maxLength={descriptionMaxLength}
                />
                {errors?.description && <span className="small text-danger">{errors?.description?.message}</span>}
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <SaveSpinnerButton
          inactiveText="Save Changes"
          activeText="Saving..."
          isSaving={isUpdating}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
        />
        <button type="button" className="btn btn-secondary" onClick={close}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default OverviewModalBody;
